<template>
  <v-container fluid class="integration-container pa-0 ma-0">
    <!-- Modern Header -->
    <div
      v-if="showHeader"
      class="header-section mb-6"
      style="margin: 0 12px; position: relative;"
    >
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-puzzle</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">Integration</h1>
          <p class="page-subtitle mb-0">
            Connect your favorite tools and platforms
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            class="mr-2 white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-link-variant</v-icon>
            Connected
          </v-chip>
          <v-chip
            class="white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-access-point</v-icon>
            Live Sync
          </v-chip>
        </div>
      </div>

      <!-- Feature Pills -->
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-shopping</v-icon>
            <span>Marketing</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-phone-in-talk</v-icon
            >
            <span>Cloud Telephony</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-webhook</v-icon>
            <span>Automation</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-application</v-icon
            >
            <span>CRM Tools</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-api</v-icon>
            <span>API Access</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <div style="padding: 0 12px;">
      <div v-for="section in integrations" :key="section.sectionName">
        <div class="section-header">
          <h3 class="font-weight-bold section-title">
            {{ section.sectionName }}
          </h3>
        </div>

        <v-row class="px-3 mb-6" dense>
          <v-col
            v-for="integration in section.integrations"
            :key="integration.name"
            class="d-flex child-flex pa-1"
            cols="12"
            sm="6"
            md="3"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="customBorderRadius secondarygrad fill-height rounded pl-0 pr-0 pt-0 pb-0 integration-card"
                :class="{ 'on-hover': hover }"
                :elevation="hover ? 12 : 2"
              >
                <div
                  class="card-header"
                  style="border-top-left-radius: 8px;border-top-right-radius: 8px;"
                >
                  <div class="header-content">
                    <v-avatar size="48" class="integration-icon elevation-2">
                      <img
                        :src="integration.image"
                        :alt="integration.name"
                        style="max-width: 100%; max-height: 100%;"
                      />
                    </v-avatar>

                    <div class="title-section">
                      <span class="integration-title">{{
                        integration.name
                      }}</span>
                      <div class="badge-container">
                        <v-chip
                          v-if="integration.beta"
                          class="beta-chip"
                          color="green"
                          text-color="white"
                          x-small
                        >
                          BETA
                        </v-chip>
                      </div>
                    </div>

                    <v-btn
                      v-if="integration.video != ''"
                      class="video-btn"
                      small
                      icon
                      :href="integration.video"
                      target="_blank"
                    >
                      <v-icon color="secondary">mdi-play-circle-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div class="spacer"></div>
                <div class="description-container">
                  <p class="description-text">{{ integration.description }}</p>
                </div>
                <div class="button-container">
                  <v-btn
                    class="connect-button"
                    color="primarygrad"
                    elevation="2"
                    block
                    @click="$router.push(integration.path)"
                  >
                    Connect
                  </v-btn>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </div>

      <!-- <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/indiamart.png" alt="External_API" style="height: 45px;width: auto;" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">IndiaMart</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Indiamart account and get all your leads directly
              into godial live.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/indiamart')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/indiamart.png" alt="External_API" style="height: 45px;width: auto;" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">
                IndiaMart V2</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Indiamart account and get all your leads directly
              into godial live.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/indiamartV2')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/justdial.png" alt="External_API" style="width: 44px;height: auto;" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">JustDial</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Justdial account and get all your leads directly into
              godial live.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/justdial')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/quikr1.png" alt="External_API" style="width: 38px;height: auto;" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">
                Quikr</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Quikr account and get all your leads directly into
              godial live.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/quikr')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <div style="padding-left: 16px;padding-top: 2%;">
      <h3 class="font-weight-medium" style="font-size: 28px;">
        Communications
      </h3>
    </div>

    <v-row class="pa-0 ma-0">
      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/interakt1.png" alt="External_API" style="width: 44px;height:auto" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Interakt</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Interakt account and get all your leads directly into
              godial live.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/interakt')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/telecmi.svg" alt="External_API" style="width: 60px;height:auto" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Tele CMI</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Tele CMI and auto dial your leads directly in GoDial.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/telecmi')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <div style="padding-left: 16px;padding-top: 2%;">
      <h3 class="font-weight-medium" style="font-size: 28px;">
        API & Connectors
      </h3>
    </div>

    <v-row class="pa-0 ma-0">
      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/external_api.png" alt="External_API" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">External API</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Push contacts from your own sources, extend the features of GoDial
              or integrate with your existing solution using the GoDial API.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/api_token')">Connect</v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/webhooks.png" alt="External_API" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Webhooks</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect GoDial with Your CRM. GoDial will call the webHook you
              specify to send data for you to consume.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/Web_Hooks')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrately.png" alt="External_API" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Integrately</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect GoDial with Facebook Ads, Google Sheets and 100s of other
              apps at much cheaper costs compared to zapier in a single click.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integrately')">Connect</v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/google_sheet.png" alt="External_API" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Google Sheet Import</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Import A Google Sheet to a GoDial list. This is a one time sync.
              We are working on a realtime sync currently.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/google_sheet')">Connect</v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <div style="padding-left: 16px;padding-top: 2%;">
      <h3 class="font-weight-medium" style="font-size: 28px;">
        CRM
      </h3>
    </div>

    <v-row class="pa-0 ma-0">
      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <img src="../assets/integrations/zoho.png" alt="External_API" style="width: 44px;height:auto" />
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Zoho</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Connect your Zoho CRM and auto dial your leads directly in GoDial.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integration/zoho')">
                  Connect
                </v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <div style="padding-left: 16px;padding-top: 2%;">
      <h3 class="font-weight-medium" style="font-size: 28px;">
        Lead Generation
      </h3>
    </div>

    <v-row class="pa-0 ma-0">
      <v-col class="d-flex child-flex" cols="12" sm="6" md="3">
        <v-hover v-slot="{ hover }">
          <v-card class="secondarygrad pa-2 fill-height rounded" :elevation="hover ? 6 : 2">
            <div class="d-flex justify-center">
              <v-avatar size="62" class="elevation-2">
                <v-icon size="36" color="deep-purple">mdi-file-document</v-icon>
              </v-avatar>
              <span style="padding-top: 20px;padding-left: 10px;font-weight: 700;">Web Forms</span>
            </div>
            <div class="pt-2">
              <h3 class="text-center text-uppercase secondary--text"></h3>
              <p class="text-center text-md-body-1 secondary--text text-lighten-1"></p>
            </div>
            <div class="d-flex justify-center text-sm-body-2 secondary--text">
              Embed a Custom Form in your Website and get Leads from it.
            </div>
            <div class="d-flex justify-center font-weight-light mt-2 text-caption secondary--text">
              <p>
                <v-btn color="primarygrad" block @click="buttonClicked('/integrate_form')">Connect</v-btn>
              </p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row> -->

      <!-- <v-row class="pa-0 ma-0">
      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-text style="height:350px;">
            <div style="width:100%; text-align:center">
              <img src="../assets/external_api.png" alt="External_API" />
            </div>
            <br />
            <h3 class="font-weight-regular title text-center">
              <v-icon>leak_add</v-icon>
              External API
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Push contacts from your own sources, extend the features of GoDial
              or integrate with your existing solution using the GoDial API.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-row class="connect-btn">
              <v-col class="px-1 mt-3">
                <v-btn
                  color="primarygrad"
                  block
                  @click="buttonClicked('/api_token')"
                  >Connect</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-text style="height:350px;">
            <div style="width:100%; text-align:center">
              <img src="../assets/integrately.png" alt="External_API" />
            </div>
            <br />
            <h3 class="font-weight-regular title text-center">
              <v-icon>mdi-web</v-icon>
              Integrately
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect GoDial with Facebook Ads, Google Sheets and 100s of other
              apps at much cheaper costs compared to zapier in a single click.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-row class="connect-btn">
              <v-col class="px-1 mt-3">
                <v-btn
                  color="primarygrad"
                  block
                  @click="buttonClicked('/integrately')"
                  >Connect</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-btn
              class="ma-md-2"
              small
              icon
              fab
              href="https://youtu.be/mfRlKBhtejo"
              target="_blank"
            >
              <v-icon large color="secondary">play_circle_filled</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/indiamart.png"
              alt="Indiamart"
              contain
              width="200px"
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              IndiaMart
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Indiamart account and get all your leads directly
              into godial live.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/integration/indiamart')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-btn
              class="ma-md-2"
              small
              icon
              fab
              href="https://youtu.be/mfRlKBhtejo"
              target="_blank"
            >
              <v-icon large color="secondary">play_circle_filled</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/indiamart.png"
              alt="Indiamart"
              contain
              width="200px"
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              IndiaMart V2
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Indiamart account and get all your leads directly
              into godial live.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/integration/indiamartV2')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/zoho.png"
              alt="Zoho"
              contain
              width="200px"
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              Zoho
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Zoho CRM and auto dial your leads directly in GoDial.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/integration/zoho')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:330px;">
            <v-img
              src="../assets/webhooks.png"
              alt="External_API"
              contain
              height="160px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center">
              <v-icon>mdi-web</v-icon>
              Webhook
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect GoDial with Your CRM. GoDial will call the webHook you
              specify to send data for you to consume.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/Web_Hooks')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-btn
              class="ma-md-2"
              small
              icon
              fab
              href="https://youtu.be/BopdkXm19Ek"
              target="_blank"
            >
              <v-icon large color="secondary">play_circle_filled</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/facebook1.png"
              alt="facebook"
              contain
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              Facebook Leads
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Receive your facebook leads directly into GoDial, simply connect
              your Lead ad form and we take care of the rest.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primarygrad" block @click="buttonClicked('/fbLeads')">
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-btn
              class="ma-md-2"
              small
              icon
              fab
              href="https://youtu.be/xJrO0ug6TDM"
              target="_blank"
            >
              <v-icon large color="secondary">play_circle_filled</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/justdial1.png"
              alt="Justdial"
              contain
              width="200px"
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              JustDial
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Justdial account and get all your leads directly into
              godial live.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/integration/justdial')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/quikr-guide.png"
              alt="Quikr"
              contain
              width="200px"
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              Quikr
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Quikr account and get all your leads directly into
              godial live.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/integration/quikr')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/interakt1.png"
              alt="Quikr"
              contain
              width="200px"
              height="150px"
              class="my-1 pa-1 pb-9 mx-auto"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              Interakt
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Interakt account and get all your leads directly into
              godial live.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              dark
              block
              @click="buttonClicked('/integration/interakt')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="fill-height rounded-lg">
          <v-col class="text-right" style="margin-bottom: -18%!important;">
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-col>
          <v-card-text style="height:350px;">
            <div class="my-10" style="width:100%; text-align:center;">
              <img
                src="../assets/integrations/cloudTelephony.png"
                alt="Cloud Telephony"
                style="height:100px;"
              />
            </div>
            <br />
            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              Cloud Telephony
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Cloud Telephony
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-row class="connect-btn">
              <v-col class="px-1 mt-3">
                <v-btn
                  color="primarygrad"
                  block
                  @click="buttonClicked('/cloudtelephony')"
                  >Connect</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-title class="pa-0 my-0">
            <v-spacer></v-spacer>
            <v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip>
          </v-card-title>
          <v-card-text style="height:325px;">
            <v-img
              src="../assets/integrations/telecmi.svg"
              alt="Tele CMI"
              style="width:100%;"
            />

            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>mdi-web</v-icon>
              Tele CMI
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Connect your Tele CMI and auto dial your leads directly in GoDial.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primarygrad"
              block
              @click="buttonClicked('/integration/telecmi')"
            >
              Connect
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-text style="height:350px;">
            <div style="width:100%; text-align:center">
              <img src="../assets/google_sheet.png" alt="External_API" />
            </div>
            <br />
            <h3 class="font-weight-regular title text-center">
              <v-icon>mdi-file-document-multiple</v-icon>
              Google Sheet Import
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Import A Google Sheet to a GoDial list. This is a one time sync.
              We are working on a realtime sync currently.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-row class="connect-btn">
              <v-col class="px-1 mt-3">
                <v-btn
                  color="primarygrad"
                  block
                  @click="buttonClicked('/google_sheet')"
                  >Connect</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="secondarygrad fill-height rounded">
          <v-card-text style="height:350px;">
            <div style="width:100%; text-align:center" class="mt-14">
              <v-icon size="80" color="deep-purple">mdi-file-document</v-icon>
              <h3 class="font-weight-medium">Web Forms</h3>
            </div>
            <br />
            <h3 class="font-weight-regular title text-center mt-9">
              <v-icon>mdi-file-document-multiple</v-icon>
              Web Forms
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              Embed a Custom Form in your Website and get Leads from it.
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-row class="connect-btn">
              <v-col class="px-1 mt-3">
                <v-btn
                  color="primarygrad"
                  block
                  @click="buttonClicked('/integrate_form')"
                  >Connect</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row> -->
    </div>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      showHeader: false,
      integrations: [
        {
          sectionName: "Marketing",
          integrations: [
            {
              name: "Facebook Lead Form Ads",
              description:
                "Connect your Facebook Lead Form Ads and auto dial your leads directly in GoDial.",
              image: require("../assets/integrations/fb.png"),
              path: "/integration/fb",
              beta: false,
              video: "https://youtu.be/BopdkXm19Ek",
            },
            {
              name: "IndiaMart",
              description:
                "Connect your Indiamart account and get all your leads directly into godial live.",
              image: require("../assets/integrations/indm.png"),
              path: "/integration/indiamart",
              beta: false,
              video: "https://youtu.be/mfRlKBhtejo",
            },
            {
              name: "IndiaMart V2",
              description:
                "Connect your Indiamart account and get all your leads directly into godial live.",
              image: require("../assets/integrations/indm.png"),
              path: "/integration/indiamartV2",
              beta: false,
              video: "https://youtu.be/mfRlKBhtejo",
            },
            {
              name: "Justdial",
              description:
                "  Connect your Justdial account and get all your leads directly into godial live.",
              image: require("../assets/integrations/jd.png"),
              path: "/integration/justdial",
              beta: false,
              video: "https://youtu.be/xJrO0ug6TDM",
            },
            {
              name: "TradeIndia",
              description:
                "  Connect your TradeIndia account and get all your leads directly into godial live.",
              image: require("../assets/integrations/ti.png"),
              path: "/integration/tradeindia",
              beta: false,
              video: "",
            },
            {
              name: "Pabbly",
              description:
                "  Connect your Pabbly account and get all your leads directly into godial live.",
              image: require("../assets/integrations/pabbly.png"),
              path: "/integration/pabbly",
              beta: false,
              video: "",
            },
            {
              name: "Quikr",
              description:
                " Connect your Quikr account and get all your leads directly into godial live.",
              image: require("../assets/integrations/qui.png"),
              path: "/integration/quikr",
              beta: false,
              video: "",
            },
            {
              name: "99acres",
              description:
                " Connect your 99acres account and get all your leads directly into godial live.",
              image: require("../assets/integrations/99.png"),
              path: "/integration/99acres",
              beta: false,
              video: "",
            },
            {
              name: "Magicbricks",
              description:
                " Connect your Magicbricks account and get all your leads directly into godial live.",
              image: require("../assets/integrations/mb1.png"),
              path: "/integration/magicbricks",
              beta: false,
              video: "",
            },
            {
              name: "Hubspot",
              description:
                "  Connect your Hubspot account and get all your leads directly into godial live.",
              image: require("../assets/integrations/hubspot.webp"),
              path: "/integration/hubspot",
              beta: false,
              video: "",
            },
            {
              name: "Housing",
              description:
                "  Connect your Housing account and get all your leads directly into godial live.",
              image: require("../assets/integrations/housing.png"),
              path: "/integration/housing",
              beta: false,
              video: "",
            },
            {
              name: "Shopify",
              description:
                "  Connect your Shopify account and get all your leads directly into godial live.",
              image: require("../assets/integrations/Shopify.webp"),
              path: "/integration/shopify",
              beta: false,
              video: "",
            },
            {
              name: "Woocommerce",
              description:
                "  Connect your Woocommerce account and get all your leads directly into godial live.",
              image: require("../assets/integrations/woo-01.png"),
              path: "/integration/woocommerce",
              beta: false,
              video: "",
            },
            {
              name: "Justdial V2",
              description:
                "  Connect your Justdial account and get all your leads directly into godial live.",
              image: require("../assets/integrations/jd.png"),
              path: "/integration/justdialv2",
              beta: false,
              video: "",
            },
            {
              name: "Google Sheet Sync",
              description:
                "  Connect your Google Sheet and get your leads directly into godial live.",
              image: require("../assets/integrations/google-sheet.png"),
              path: "/integration/googleSheetSync",
              beta: false,
              video: "",
            },
            {
              name: "Google Sheet Import",
              description:
                " Import A Google Sheet to a GoDial list. This is a one time sync. We are working on a realtime sync currently.",
              image: require("../assets/google_sheet.png"),
              path: "/google_sheet",
              beta: false,
              video: "",
            },
          ],
        },
        // {
        //   sectionName: "Communications",
        //   integrations: [
        //     {
        //       name: "Interakt",
        //       description:
        //         "Send events and leads from GoDial to Interakt for Whatsapp",
        //       image: require("../assets/integrations/intr.png"),
        //       path: "/integration/interakt",
        //       beta: false,
        //       video: "",
        //     },
        //     {
        //       name: "Telecmi",
        //       description:
        //         "Connect your Tele CMI and auto dial your leads directly in GoDial.",
        //       image: require("../assets/integrations/telecmi.svg"),
        //       path: "/integration/telecmi",
        //       beta: false,
        //       video: "",
        //     },
        //   ],
        // },
        {
          sectionName: "API & Connectors",
          integrations: [
            {
              name: "External API",
              description:
                "Push contacts from your own sources, extend the features of GoDial or integrate with your existing solution using the GoDial API.",
              image: require("../assets/external_api.png"),
              path: "/api_token",
              beta: false,
              video: "",
            },
            {
              name: "Webhook",
              description:
                "Connect GoDial with Your CRM. GoDial will call the webHook you specify to send data for you to consume.",
              image: require("../assets/webhooks.png"),
              path: "/Web_Hooks",
              beta: false,
              video: "",
            },
            {
              name: "Integrately",
              description:
                "Connect GoDial with Facebook Ads, Google Sheets and 100s of other apps at much cheaper costs compared to zapier in a single click.",
              image: require("../assets/integrately.png"),
              path: "/integrately",
              beta: false,
              video: "",
            },
          ],
        },
        {
          sectionName: "CRM",
          integrations: [
            {
              name: "Zoho",
              description:
                "Connect your Zoho CRM and auto dial your leads directly in GoDial.",
              image: require("../assets/integrations/zoho.png"),
              path: "/integration/zoho",
              beta: false,
              video: "",
            },
          ],
        },
        {
          sectionName: "Lead Generation",
          integrations: [
            {
              name: "Web Forms",
              description:
                " Embed a Custom Form in your Website and get Leads from it.",
              image: require("../assets/integrations/webforms.png"),
              path: "/integrate_form",
              beta: false,
              video: "",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.showHeader =
      localStorage.getItem("integrationHeaderDismissed") !== "true";
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("integrationHeaderDismissed", "true");
    },
    buttonClicked(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* Modern Design System */
.integration-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .integration-container {
  background-color: #121212 !important;
}

/* Card Styles */
.v-card {
  margin: 0;
  transition: transform 0.3s, box-shadow 0.3s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.integration-card {
  border-radius: 12px !important;
  padding-top: 0 !important;
}

.theme--dark .integration-card {
  background: #1e1e1e !important;
}

.on-hover {
  transform: translateY(-5px);
}

.card-header {
  background: transparent;
  padding: 0;
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
  margin-top: 0;
  position: relative;
  overflow: hidden;
}

.theme--dark .card-header {
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.header-content {
  display: flex;
  align-items: center;
  padding: 16px;
  position: relative;
}

.integration-icon {
  flex-shrink: 0;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title-section {
  flex: 1;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
}

.integration-title {
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.3px;
  line-height: 1.3;
  margin-bottom: 2px;
}

.badge-container {
  display: flex;
  align-items: center;
  margin-top: 2px;
}

.beta-chip {
  height: 20px !important;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0 6px;
}

.video-btn {
  flex-shrink: 0;
  margin-left: 4px;
  background-color: rgba(255, 255, 255, 0.7) !important;
  transition: all 0.2s ease;
}

.video-btn:hover {
  background-color: white !important;
  transform: scale(1.1);
}

.spacer {
  height: 5px;
}

.description-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 16px;
}

.description-text {
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: auto;
}

.theme--dark .description-text {
  color: #b0b0b0 !important;
}

.button-container {
  padding: 16px;
  margin-top: auto;
}

.connect-button {
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
  height: 40px;
}

.connect-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.section-header {
  padding: 1.5rem 0 0.75rem 1rem;
}

.section-title {
  font-size: 1.75rem;
  position: relative;
  padding-left: 0.5rem;
  margin-bottom: 0.5rem;
}

.section-title::before {
  content: "";
  position: absolute;
  left: -0.5rem;
  top: 0.25rem;
  height: 80%;
  width: 4px;
  background: linear-gradient(to bottom, #42b883, #2f9768);
  border-radius: 4px;
}
</style>
